var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#00FF00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2781 25C16.2314 25 16.1851 24.9891 16.1419 24.9678C16.0988 24.9465 16.0595 24.9153 16.0265 24.876L11.0998 19.0083C11.035 18.9284 10.9992 18.8215 11 18.7105C11.0008 18.5995 11.0382 18.4933 11.1041 18.4148C11.17 18.3364 11.2592 18.2918 11.3524 18.2909C11.4456 18.2899 11.5354 18.3326 11.6024 18.4097L16.2781 23.9794L25.3929 13.1241C25.4596 13.0446 25.55 13 25.6443 13C25.7387 13 25.8291 13.0446 25.8958 13.1241C25.9625 13.2035 26 13.3112 26 13.4236C26 13.5359 25.9625 13.6436 25.8958 13.7231L16.5294 24.8777C16.4626 24.9564 16.3722 25.0004 16.2781 25Z",
    fill: "#1A5050",
    stroke: "#1A5050",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f3c2a7194120212eb9fed5b930132176.svg";
export { ForwardRef as ReactComponent };